export class Retailer {
    name:string;
    amount:string;
    password:string;
    fund_mobile:string;
    fund_amount:string
}
